module.exports = {"data":{"markdownRemark":{"html":"<p>Form guidelines go here</p>","frontmatter":{"path":"/guidelines/data-entry","tags":null,"kicker":null,"title":"Data entry","description":"High-level form guidelines","status":"Complete","group":"guidelines","usage":null,"use":null,"altUse":null}}},"pathContext":{"slug":"/guidelines/data-entry/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/guidelines-data-entry.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/guidelines-data-entry.json
// module chunks = 104141920851818